import { translate } from '@avalara/bat-apps-shared/i18n';
import { SBox } from '@avalara/skylab-sdk/react';
import styled from 'styled-components';

import type { ExemptionsPlanClientDetails, OfferPlanClientDetails } from '../../../../../../types/offers';

import { formatPrice } from '../../../../../shared/helpers';
import { getOfferPlanPrice } from '../../../../lib/offers';
import SelectPlanButton from '../shared/select-plan-button';
import { FixedWidthPlanWrapper } from '../shared/styles';
const HalfHr = styled.hr`
  width: 50%;
  margin: auto;
`;

const NormalHeightP = styled.p`line-height: normal !important;`;

type Props = {
  plan: OfferPlanClientDetails & ExemptionsPlanClientDetails;
  onSelect: () => void;
  selected: boolean;
  isDisabled?: boolean;
};

const ExemptionsOfferPlan = ({ plan, onSelect, selected, isDisabled }: Props) => {
  const offerPlanPrice = getOfferPlanPrice(plan);

  return (
    <FixedWidthPlanWrapper onClick={onSelect} selected={selected} disabled={isDisabled}>
      <SBox className='margin-bottom-sm margin-top-xs text-center'>
        <div className='margin-all-sm'>
          {translate('client.general.up-to-certificates', {
            count: plan.certificatesIncluded || '---',
            label: (chunks) => <p className='text-md'>{chunks}</p>,
            countValue: (chunks) => <NormalHeightP className='text-xxl'>{chunks}</NormalHeightP>,
            unit: (chunks) => <p className='text-md'>{chunks}</p>,
          })}
        </div>

        <HalfHr />

        <div className='margin-all-sm'>
          <p className='text-md inline font-light'>{formatPrice(offerPlanPrice, 0)}</p>
          <p className='text-md inline font-light'> annually</p>
        </div>

        <div className='pad-bottom-sm pad-top-md'>
          <SelectPlanButton isSelected={selected} planName={plan.name} disableButton={isDisabled} />
        </div>
      </SBox>
    </FixedWidthPlanWrapper>
  );
};

export default ExemptionsOfferPlan;
